import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ClientBackground from '../components/ClientBackground';
import { Sparkles, CheckCircle } from 'lucide-react';

const CongratsPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const confettiColors = ['#FDB913', '#FFA500', '#1e3a5f', '#7FE5D3', '#FDB5C8'];
    const confettiElements = [];

    for (let i = 0; i < 50; i++) {
      const confetti = document.createElement('div');
      confetti.className = 'confetti';
      confetti.style.left = Math.random() * 100 + '%';
      confetti.style.backgroundColor = confettiColors[Math.floor(Math.random() * confettiColors.length)];
      confetti.style.animationDelay = Math.random() * 3 + 's';
      confetti.style.animationDuration = Math.random() * 3 + 2 + 's';
      document.getElementById('confetti-container')?.appendChild(confetti);
      confettiElements.push(confetti);
    }

    return () => {
      confettiElements.forEach(el => el.remove());
    };
  }, []);

  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <ClientBackground />
      
      <div id="confetti-container" className="absolute inset-0 pointer-events-none z-20"></div>

      <div className="relative z-10 w-full max-w-md px-5">
        <div className="bg-white rounded-3xl shadow-2xl p-8 text-center">
          <div className="mb-6 relative">
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-32 h-32 bg-[#FDE9EB] rounded-full opacity-60 blur-2xl animate-pulse"></div>
            </div>
            
            <div className="relative flex justify-center">
              <div className="relative">
                <div className="w-24 h-24 bg-gradient-to-br from-[#FDB913] to-[#FFA500] rounded-full flex items-center justify-center shadow-lg">
                  <CheckCircle className="w-14 h-14 text-white" strokeWidth={2.5} />
                </div>
                <Sparkles className="absolute -top-2 -right-2 w-8 h-8 text-[#FDB913] animate-bounce" />
                <Sparkles className="absolute -bottom-1 -left-1 w-6 h-6 text-[#FFA500] animate-pulse" />
              </div>
            </div>
          </div>

          <h1 className="text-3xl font-bold text-[#1e3a5f] mb-4">
            Congratulations!
          </h1>

          <div className="space-y-2 mb-8">
            <p className="text-gray-700 text-base font-medium">
              Your child's profile is now complete!
            </p>
            <p className="text-gray-600 text-sm">
              You're all set to start tracking their developmental journey.
            </p>
          </div>

          <div className="bg-gradient-to-br from-blue-50 to-purple-50 rounded-2xl p-4 mb-8">
            <p className="text-sm text-[#1e3a5f] font-medium">
              Let's nurture each step of their development together!
            </p>
          </div>

          <button
            onClick={() => navigate('/client-dashboard')}
            className="w-full bg-[#1e3a5f] text-white py-4 rounded-xl font-semibold text-base shadow-md hover:bg-[#152e4a] transition-all hover:shadow-lg active:scale-98"
          >
            Go to Dashboard
          </button>

          <div className="mt-6 flex justify-center">
            <div className="h-1 w-32 rounded-full bg-gray-800"></div>
          </div>
        </div>
      </div>

      <style jsx="true">{`
        @keyframes confetti-fall {
          0% {
            transform: translateY(-100vh) rotate(0deg);
            opacity: 1;
          }
          100% {
            transform: translateY(100vh) rotate(720deg);
            opacity: 0;
          }
        }

        .confetti {
          position: absolute;
          width: 10px;
          height: 10px;
          top: -10px;
          animation: confetti-fall linear infinite;
        }

        @keyframes pulse {
          0%, 100% {
            opacity: 0.6;
          }
          50% {
            opacity: 0.8;
          }
        }

        @keyframes bounce {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
        }

        .animate-pulse {
          animation: pulse 2s ease-in-out infinite;
        }

        .animate-bounce {
          animation: bounce 1s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default CongratsPage;